<app-card
  [cardTitle]="'pages.change-password.label' | translate"
  [cardTitle]="'pages.change-password.title' | translate"
  [cardHelp]="'pages.change-password.help' | translate: {
    'minPasswordLength': minPasswordLengthText,
    'maxPasswordLength': maxPasswordLengthText,
    'minPasswordUppercase': minPasswordUppercaseText,
    'minPasswordLowercase': minPasswordLowercaseText,
    'minPasswordDigits': minPasswordDigitsText,
    'minPasswordHistory': minPasswordHistoryText,
    'minPasswordSymbols': minPasswordSymbolsText
  }">
</app-card>
